module.exports = __webpack_public_path__ + "static/GitHub-89c2c0674bdba3d61daf6b1b1e5e82b5.png";